import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface CapacitacionView {
  id: number;

  nombre: string;
  descripcion: string | null;
  tema: string | null;
  estado: number;
  fechaCreacion: string;
  fechaModificacion: string | null;
}

/**
 * 🔹 CREATE / UPDATE DTO
 */
export interface CapacitacionDTO {
  nombre: string;
  descripcion?: string | null;
  tema?: string | null;
  estado?: number;
}

@Injectable({
  providedIn: "root",
})
export class CapacitacionesService {
  private apiUrl = `${environment.apiUrl}/api/capacitacion`;

  constructor(private http: HttpClient) {}


  getCapacitaciones(): Observable<CapacitacionView[]> {
    return this.http
      .get<CapacitacionView[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getAllCapacitacionesActivos(): Observable<CapacitacionView[]> {
    return this.http
      .get<
        CapacitacionView[]
      >(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getCapacitacionById(id: string | number): Observable<CapacitacionView> {
    return this.http
      .get<CapacitacionView>(`${this.apiUrl}/${id}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  createCapacitacion(payload: CapacitacionDTO): Observable<any> {
    return this.http
      .post<any>(this.apiUrl, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  updateCapacitacion(
    id: string | number,
    payload: CapacitacionDTO,
  ): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}`, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  deleteCapacitacion(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/${id}/activar`,
        {},
        {
          withCredentials: true,
        },
      )
      .pipe(catchError((error) => throwError(() => error)));
  }

  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/${id}/inactivar`,
        {},
        {
          withCredentials: true,
        },
      )
      .pipe(catchError((error) => throwError(() => error)));
  }
}